import api from './api';

/**
 * Create a tracking function configured with a particular "view" and "section".
 * Returned function accepts params for "identifier" and "extra_content", for
 * tracking individual events.
 *
 * @return  {Function}  function for tracking events
 */
export default (view, section) => {
  return (identifier = null, extra_content, type_id) => {
    const page = window.location.pathname;

    return api.track({
      identifier,
      page,
      view,
      section,
      type_id,
      extra_content,
    });
  }
}
